import announcementsService from "@/services/announcements";

const getDefaultState = () => {
    return {
        dataSource: [],
        loadingStatus : false,
    };
};

export const state = getDefaultState();

export const actions = {
    addAnnouncement({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            announcementsService
            .addAnnouncement(payload)
            .then((data) => {
                resolve(data);
                this._vm.$toast.success(data.message);
            })
            .catch((err) => {
                reject(err);
                this._vm.$toast.error(err.message);

            });
        });
    },  
    fetchAllAnnouncements() {
        return new Promise((resolve, reject) => {
            announcementsService
            .getAnnouncements()
            .then((data) => {
                resolve(data.data);
            })
            .catch((err) => {
                reject(err);
                // err.status != 401 && this._vm.$toast.error(err.message);
            });
        });
    },  
    fetchAnnouncement({ commit }, id) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            announcementsService
            .getAnnouncement(id)
            .then((data) => {
                resolve(data.data);
            })
            .catch((err) => {
                reject(err);
                err.status != 401 && this._vm.$toast.error(err.message);
            });
        });
    },
    editAnnouncement({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            announcementsService
            .editAnnouncement(payload)
            .then((data) => {
              resolve(data);
              this._vm.$toast.success("Announcement has been updated successfully.");
            })
            .catch((err) => {
                reject(err);
                this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
            });
        });
    },   
    deleteAnnouncement({ commit }, id) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            announcementsService
            .deleteAnnouncement(id)
            .then((data) => {
                resolve(data);
                this._vm.$toast.success(data.message);
            })
            .catch((err) => {
                reject(err);
                err.status != 401 && this._vm.$toast.error(err.message);
            });
        });
    },    
};

export const mutations = {
    setLoadingStatus(state, loading) {
        state.loadingStatus = loading;
    },
}

export const getters = {
    
};